import { ImageOptimization } from '@/containers/ImageOptimization'
import { isObjectNotEmpty } from '@/helpers/shadcn/utils'
import {
  ActivitiesList,
  AddActivity,
  AddActivityReview,
  AddSalesTarget,
  AddSalesTargetDisplayContent,
  AddSalesTargetProduct,
  BulkModifiersHome,
  ClubPlusHome,
  CreateBulkPointModifiers,
  CreateTier,
  DynamicTable,
  PageError404,
  PointMultiplier,
  ReviewBulkPointModifiers,
  ReviewPointMultiplier,
  SalesTargetHome,
  SalesTargetReview,
  StoreDetails,
  StoreListPage,
  StoreName,
  TestPage,
} from '@/pages'
import { PageError403 } from '@/pages/Errors/403'
import { PageError500 } from '@/pages/Errors/500'
import { CreatePointMultiplier, ProductsPointMultiplier } from '@/pages/PointMultiplier/index'
import { UserDetails } from '@/services/UserDetails'
import { useAppDispatch } from '@/store'
import { setShellActive, setShellPath } from '@/store/slices/commonSlice'
import { setCountryCode } from '@/store/slices/countryCodeSlice'
import { setUserDetails } from '@/store/slices/userSlice'
import { ROUTES } from '@/utils/constants/routesConstants'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { createBrowserRouter, RouterProvider } from 'react-router-dom'
import { ProtectedRoutes } from './ProtectedRoutes'


const clubPlusRoutes = [
  { path: ROUTES.CLUB_HOME, element: <ClubPlusHome /> },
  { path: ROUTES.CREATE_TIER, element: <CreateTier /> },
]

const router = createBrowserRouter([
  {
    element: <ProtectedRoutes />,
    children: [
      { path: ROUTES.HOME, element: <SalesTargetHome instanceKey="activities" selectedTab="activities" /> },

      { path: ROUTES.SALES_TARGETS, element: <SalesTargetHome instanceKey="sales-target" selectedTab="sales-target" /> },
      { path: ROUTES.SALES_TARGET_ADD, element: <AddSalesTarget /> },
      { path: ROUTES.SALES_TARGET_DISPLAY_CONTENT, element: <AddSalesTargetDisplayContent /> },
      { path: ROUTES.SALES_TARGET_PRODUCTS, element: <AddSalesTargetProduct /> },
      { path: ROUTES.SALES_TARGET_REVIEW, element: <SalesTargetReview /> },
      { path: ROUTES.SALES_TARGET_DETAIL, element: <SalesTargetReview /> },

      { path: ROUTES.ACTIVITIES, element: <SalesTargetHome instanceKey="activities" selectedTab="activities" /> },
      { path: ROUTES.ACTIVITY_ADD, element: <AddActivity /> },
      { path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview /> },

      { path: ROUTES.POINT_MULTIPLIER, element: <PointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_CREATE, element: <CreatePointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_REVIEW, element: <ReviewPointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_VIEW, element: <ReviewPointMultiplier /> },
      { path: ROUTES.POINT_MULTIPLIER_PRODUCTS, element: <ProductsPointMultiplier /> },

      { path: ROUTES.BULK_POINT_MODIFIERS, element: <BulkModifiersHome /> },
      { path: ROUTES.BULK_POINT_MODIFIER_CREATE, element: <CreateBulkPointModifiers /> },
      { path: ROUTES.BULK_POINT_MODIFIER_REVIEW, element: <ReviewBulkPointModifiers /> },
      { path: ROUTES.BULK_POINT_MODIFIER_VIEW, element: <ReviewBulkPointModifiers /> },

      { path: ROUTES.STORE_NAME, element: <StoreName /> },
      { path: ROUTES.ACTIVITY_ADD, element: <AddActivity /> },
      { path: ROUTES.ACTIVITY_REVIEW, element: <AddActivityReview /> },
      {path: ROUTES.ACTIVITY_VIEW, element: <AddActivityReview />},
      { path: ROUTES.ACTIVITIES, element: <ActivitiesList /> },
      { path: ROUTES.STORE_LIST, element: <StoreListPage /> },
      { path: ROUTES.TABLE, element: <DynamicTable /> },
      { path: ROUTES.STORE_DETAILS, element: <StoreDetails /> },

      { path: ROUTES.TABLE, element: <DynamicTable /> },
      { path: ROUTES.IMAGE, element: <ImageOptimization /> },
      { path: ROUTES.ADD_SALES_TARGET_DETAIL, element: <SalesTargetReview /> },
      { path: ROUTES.PRODUCTS_POINT_MULTIPLIER,element: <ProductsPointMultiplier/>},
      /* Errors */
      { path: ROUTES.ERROR_500, element: <PageError500 /> },
      { path: ROUTES.ERROR_403, element: <PageError403 /> },
      { path: '*', element: <PageError404 /> },

      { path: ROUTES.TEST, element: <TestPage /> },
      /* Products */
      ...clubPlusRoutes,
    ],
  },
])

export const AppRouter = ({ shellActive, darkTheme, path, market }) => {

  const dispatch = useAppDispatch()

  const userData = useSelector(state => state?.userDetails)
  const getUserData = async () => {
    if (!isObjectNotEmpty(userData)) {
      try {
        await UserDetails()
        const reqData = {
          name: 'Robert',
          role: ['admin', 'super-admin'],
          country: [{ name: 'Mexico', lang: [{ langcode: 33, name: 'mexico' }] }],
          countryCode: 'mx',
          siteId: 21,
        }
        dispatch(setUserDetails(reqData))
      } catch {
        const reqData = {
          name: 'Louis',
          role: ['admin'],
          country: [{ name: 'Turkey', lang: [{ langcode: 31, name: 'Turkey' }] }],
          countryCode: 'TR',
          siteId: 23,
        }
        dispatch(setUserDetails(reqData))
      }
    }
  }
  useEffect(() => {
    getUserData()
  })
  useEffect(() => {
    dispatch(setShellActive(shellActive))
    if (market) {
      dispatch(setCountryCode(market))
    }
  }, [shellActive, dispatch, market])

  useEffect(() => { }, [darkTheme])

  // expected everytime to dispatch the shell path when component is mounted to navigate properly
  useEffect(() => {
    dispatch(setShellPath(path))
  })

  // Use market as key to force remount (refresh) when market changes
  return (

      <RouterProvider key={market || 'default'} router={router} />
  )
}
